import Vue from 'vue';
import { commentNode } from '@/helper/vue';

Vue.directive('role', function (el, binding, vnode) {
    let ok = false;
    const behaviour = binding.modifiers;
    const hasUser = ca.user && Object.keys(ca.user).length > 0;
    const role = binding.arg;

    switch (role) {
        case 'super':
            ok = hasUser && ca.user.super;
            break;
        case 'staff':
            ok = hasUser;
            break;
    }

    if (!ok) {
        if (behaviour.readonly) {
            el.readonly = true;
        } else if (behaviour.disable) {
            el.disabled = true;
        } else {
            commentNode(el, vnode);
        }
    }
});
